<template>
  <i-select :value="value" v-on="$listeners">
    <i-option
      v-for="action in filtered_actions"
      :key="action.id"
      :value="action.id"
      :label="action.getName()"
    />
  </i-select>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },
    computed: {
      ...mapGetters('pbx/worksheets/form', { get_actions: 'getActions' }),

      filtered_actions: function() {
        return this.get_actions.filter(action => action.type !== 'entry');
      }
    }
  };
</script>
